<template>
    <div>
        <button
            :class="buttonClass"
            @click="$modal.show('edit-sales-agent')"
        >
            <slot>Redigera</slot>
        </button>

        <adaptive-form-modal
            name="edit-sales-agent"
            title="Redigera säljare"
            method="patch"
            :action="route('api.orders.sales-agent.update', order.id)"
            :redirect-to="redirectTo"
        >
            <text-input
                v-model="salesAgent"
                :autofocus="true"
                :native-label="placeholder"
                label="Säljare"
                name="sales_agent"
            />
        </adaptive-form-modal>
    </div>
</template>

<script>

    export default {
        props: {
            order: {
                type: Object,
                required: true,
            },
            assignedSeller: {
                type: String,
                required: false,
                default: null,
            },
            initialSalesAgent: {
                type: String,
                required: false,
                default: null,
            },
            redirectTo: {
                type: String,
                required: true,
            },
            buttonClass: {
                type: String,
                default: 'btn btn-md is-primary',
            },
        },

        data() {
            return {
                salesAgent: this.initialSalesAgent,
            };
        },

        computed: {
            placeholder() {
                if (this.assignedSeller) {
                    return this.assignedSeller;
                }

                return '';
            },
        },

        watch: {
            salesAgent(newValue) {
                const withoutInvalidChars = newValue.replace(/["\\]/g, '');

                const normalized = withoutInvalidChars.replace(/[\s]+/g, ' ');

                this.$nextTick(() => {
                    this.salesAgent = normalized;
                });
            },
        },

    };
</script>
